import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './HistoryTable.css';
import HistoryRow from './HistoryRow';
import RowButton from './RowButton';

function HistoryTable(props) {
  // Create an array where the value in position i is if the row i is expanded or not
  const [expandedRows, setExpandedRows] = useState(props.appointments.map(() => false));

  const allRowsExpanded = expandedRows.reduce((a, b) => a && b);

  const onRowDropdownClick = index => {
    const newExpandedRows = expandedRows.concat([]);
    newExpandedRows.splice(index, 1, !expandedRows[index]);
    setExpandedRows(newExpandedRows);
  }

  const onHeaderDropdownClick = () => {
    setExpandedRows(props.appointments.map(() => allRowsExpanded ? false : true));
  }

  return (
    <table className={css['table']}>
      <thead>
        <tr>
          <th>Student(s)</th>
          <th>Type</th>
          <th>Reason</th>
          <th>Service Center</th>
          <th>Checked In</th>
          <th>Checked Out</th>
          <th>
            <div>
              <RowButton
                icon={allRowsExpanded ? "arrow_drop_up" : "arrow_drop_down"} 
                label={`${allRowsExpanded ? "Collapse" : "Expand"} all details`}
                onClick={onHeaderDropdownClick}
              />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.appointments.map((appointment, i) => (
          <HistoryRow 
            key={i}
            appointment={appointment} 
            openStudentFolder={props.openStudentFolder}
            editAppointment={props.editAppointment}
            handleGroupSession={props.handleGroupSession}
            formatDate={props.formatDate}
            getAppointmentsHistory={props.getAppointmentsHistory}
            onDropdownClick={() => onRowDropdownClick(i)}
            isExpanded={expandedRows[i]}
            setError={props.setError}
          />
        ))}
      </tbody>
    </table>
  );
}

HistoryTable.propTypes = {  
  appointments: PropTypes.array.isRequired,
  openStudentFolder: PropTypes.func.isRequired,
  editAppointment: PropTypes.func.isRequired,
  handleGroupSession: PropTypes.func.isRequired,
  getAppointmentsHistory: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

export default HistoryTable;
